<p class="helppoint-title">{{data.title}}</p>
<input-component class="col-x" [(ngModel)]="data.plateA"
    placeholder="{{'ECMR.PLATES.PLATE_A' | translate}}"></input-component>
<input-component class="col-x" [(ngModel)]="data.plateB"
    placeholder="{{'ECMR.PLATES.PLATE_B' | translate}}"></input-component>
<input-component class="col-x" [(ngModel)]="data.plateC"
    placeholder="{{'ECMR.PLATES.PLATE_C' | translate}}"></input-component>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
